import { Plan } from "@/types";
import { FAQ } from "@/types";
import { Icons } from "@/components/(new)/shared/helper/Icons";
import { AspectRatioOption, Styles } from "@/types";
import {
  Maximize2,
  ImageDown,
  Camera,
  Image as ImageIcon,
  Tv,
} from "lucide-react";
import Instagram from "@/public/assets/icons/SocialMedia/Instagram.svg";
import Pinterest from "@/public/assets/icons/SocialMedia/Pinterest.svg";
import Youtube from "@/public/assets/icons/SocialMedia/Youtube.svg";
import { aiAvatarPrompt } from "@/constants/prompt";

// SVG Generator constants
export const SVG_STYLES = [
  // Vector illustration styles
  {
    value: "vector_illustration",
    label: "Vector Illustration",
    group: "Vector Illustration",
  },
  {
    value: "vector_illustration/cartoon",
    label: "Cartoon",
    group: "Vector Illustration",
  },
  {
    value: "vector_illustration/doodle_line_art",
    label: "Doodle Line Art",
    group: "Vector Illustration",
  },
  {
    value: "vector_illustration/engraving",
    label: "Engraving",
    group: "Vector Illustration",
  },
  {
    value: "vector_illustration/flat_2",
    label: "Flat 2.0",
    group: "Vector Illustration",
  },
  {
    value: "vector_illustration/kawaii",
    label: "Kawaii",
    group: "Vector Illustration",
  },
  {
    value: "vector_illustration/line_art",
    label: "Line Art",
    group: "Vector Illustration",
  },
  {
    value: "vector_illustration/line_circuit",
    label: "Line Circuit",
    group: "Vector Illustration",
  },
  {
    value: "vector_illustration/linocut",
    label: "Linocut",
    group: "Vector Illustration",
  },
  {
    value: "vector_illustration/seamless",
    label: "Seamless",
    group: "Vector Illustration",
  },
  // Icon styles
  { value: "icon", label: "Icon", group: "Icon" },
  { value: "icon/broken_line", label: "Broken Line", group: "Icon" },
  { value: "icon/colored_outline", label: "Colored Outline", group: "Icon" },
  { value: "icon/colored_shapes", label: "Colored Shapes", group: "Icon" },
  {
    value: "icon/colored_shapes_gradient",
    label: "Colored Shapes Gradient",
    group: "Icon",
  },
  { value: "icon/doodle_fill", label: "Doodle Fill", group: "Icon" },
  {
    value: "icon/doodle_offset_fill",
    label: "Doodle Offset Fill",
    group: "Icon",
  },
  { value: "icon/offset_fill", label: "Offset Fill", group: "Icon" },
  { value: "icon/outline", label: "Outline", group: "Icon" },
  { value: "icon/outline_gradient", label: "Outline Gradient", group: "Icon" },
  { value: "icon/uneven_fill", label: "Uneven Fill", group: "Icon" },
];

export const SVG_ASPECT_RATIOS = [
  { value: "1:1", label: "1:1 (Square)" },
  { value: "4:3", label: "4:3" },
  { value: "3:4", label: "3:4" },
  { value: "3:2", label: "3:2" },
  { value: "2:3", label: "2:3" },
  { value: "16:9", label: "16:9 (Widescreen)" },
  { value: "9:16", label: "9:16 (Portrait)" },
  { value: "1:2", label: "1:2" },
  { value: "2:1", label: "2:1" },
  { value: "7:5", label: "7:5" },
  { value: "5:7", label: "5:7" },
  { value: "4:5", label: "4:5" },
  { value: "5:4", label: "5:4" },
  { value: "3:5", label: "3:5" },
  { value: "5:3", label: "5:3" },
];

export const sidebarlinks = [
  {
    icon: Icons.generator,
    title: "Image generator",
    href: "/image-generator",
  },
  {
    icon: Icons.editor,
    title: "Image editor",
    href: "/image-editor",
  },
  {
    icon: Icons.videoGenerator,
    title: "Video generator",
    href: "/video-generator",
  },
  {
    icon: Icons.settings,
    title: "More tools",
    href: "/dashboard",
  },
  {
    icon: Icons.history,
    title: "History",
    href: "/history",
  },
  {
    icon: Icons.explore,
    title: "Inspiration",
    href: "/inspiration",
  },
];

export const proPricingTiers = [
  {
    price: 5,
    credits: 500,
    planId: "pdt_YlrMc8DClvd9kqeLiodw5",
  },
  {
    price: 10,
    credits: 1000,
    planId: "pdt_45cudvYN7K8vQ6p74aWwa",
  },
  {
    price: 15,
    credits: 1500,
    planId: "pdt_4tW9SmR63alNvcsZAFMA5",
  },
  {
    price: 20,
    credits: 2000,
    planId: "pdt_V3VCqooaGA5Inm9GW5jpI",
  },
  {
    price: 25,
    credits: 2500,
    planId: "pdt_JvsgZHuum2KHyFAlMatAe",
  },
  {
    price: 30,
    credits: 3000,
    planId: "pdt_YEcrtr6OORtF8Subj6oUg",
  },
  {
    price: 35,
    credits: 3500,
    planId: "pdt_YEcrtr6OORtF8Subj6oUg",
  },
  {
    price: 40,
    credits: 4000,
    planId: "pdt_Lpe3yWSIkHdk2xFsle8qX",
  },
  {
    price: 45,
    credits: 4500,
    planId: "pdt_8EqcvlfXZBreqkhqwBiQ0",
  },
  {
    price: 50,
    credits: 5000,
    planId: "pdt_zGgLcnN5PPHaBB2DIuK2s",
  },
  {
    price: 55,
    credits: 5500,
    planId: "pdt_mpNjV6HgnVZgIF2UOQj5S",
  },
  {
    price: 60,
    credits: 6000,
    planId: "pdt_jRvudLp5X2Y0VyKIMS6gT",
  },
  {
    price: 65,
    credits: 6500,
    planId: "pdt_EmFOqD0hEGoSCZEST8bOA",
  },
  {
    price: 70,
    credits: 7000,
    planId: "pdt_sxanFgwtBEvhK1TnrH9CB",
  },
  {
    price: 80,
    credits: 8000,
    planId: "pdt_H65XNSJEOcpNl99RccENA",
  },
  {
    price: 90,
    credits: 9000,
    planId: "pdt_Hh0wURmBbNsD6KRyBH5Ix",
  },
  {
    price: 100,
    credits: 10000,
    planId: "pdt_bICMnXzOoTrAs65ZUyWMQ",
  },
];

// Simple formula: $1 = 100 credits

export const plans = [
  {
    name: "Free Plan",
    price: "0",
    credits: "100",
    features: [
      "Can't buy more credits",
      "Credits expire monthly",
      "1 GB storage",
      "Video export at 720p",
    ],
    dashedfeatures: ["Priority support", "Access to new beta AI models"],
  },
  {
    name: "Pro Plan",
    features: [
      "Can buy more credits",
      "Credits roll over monthly",
      "10 GB storage",
      "4K download",
      "Priority support",
    ],
    dashedfeatures: ["Access to new beta AI models"],
  },
  {
    name: "Enterprise Plan",
    features: [
      "Custom Credits",
      "Unlimited storage",
      "4K download",
      "Priority support",
      "Access to new beta AI models",
      "Dedicated account manager",
    ],
  },
];

export const RESOLUTIONS = [
  // Common aspect ratios
  "16:9", // Widescreen
  "9:16", // Portrait
  "4:3", // Standard
  "3:4", // Portrait
  "1:1", // Square
  "21:9", // Ultra-wide
  "3:2", // DSLR Photo
  "2:3", // Portrait Photo
  // Specific resolutions
  "704*1408",
  "704*1344",
  "768*1344",
  "768*1280",
  "832*1216",
  "832*1152",
  "896*1152",
  "896*1088",
  "960*1088",
  "960*1024",
  "1024*1024",
  "1024*960",
  "1088*960",
  "1088*896",
  "1152*896",
  "1152*832",
  "1216*832",
  "1280*768",
  "1344*768",
  "1344*704",
  "1408*704",
  "1472*704",
  "1536*640",
  "1600*640",
  "1664*576",
  "1728*576",
] as const;

export const creditAddOns = [
  {
    name: "Small Boost",
    price: "20",
    credits: "2000",
    variantId: "516937", // Replace with actual Lemon Squeezy variant ID
  },
  {
    name: "Medium Boost",
    price: "50",
    credits: "6000",
    variantId: "516938", // Replace with actual Lemon Squeezy variant ID
  },
  {
    name: "Large Boost",
    price: "100",
    credits: "13000",
    variantId: "516939", // Replace with actual Lemon Squeezy variant ID
  },
];

export const faqData: FAQ[] = [
  {
    question: "What is Background Remover used for?",
    answer:
      "The Background Remover tool is designed to remove backgrounds from photos, allowing you to isolate objects or people in an image. It helps you create clean, transparent backgrounds effortlessly.",
  },
  {
    question: "How does the Caption Generator work?",
    answer:
      "The Caption Generator tool enhances your images by automatically generating captions based on the content of the image. It fills in the blanks with descriptive text, making your images more engaging and informative.",
  },
  {
    question: "What can I do with the Image Generator tool?",
    answer:
      "The Image Generator tool allows you to create new images from scratch or based on text prompts. It uses AI to generate visually appealing images that match your input, helping you bring your creative ideas to life.",
  },
  {
    question: "How effective is the Image Upscaler?",
    answer:
      "The Image Upscaler tool enhances the resolution and quality of your images without losing detail. It uses advanced algorithms to upscale images while preserving clarity and sharpness, making them suitable for various applications.",
  },
];

export const navLinks = [
  { href: "/tools", label: "Tools" },
  { href: "/blog", label: "Blog" },
  { href: "/explore", label: "Explore" },
  { href: "/pricing", label: "Pricing" },
];
export const loggedNavLinks = [
  { href: "/tools", label: "Tools" },
  { href: "/blog", label: "Blogs" },
  { href: "/explore", label: "Explore" },
  { href: "/pricing", label: "Pricing" },
];

export const imagesArrys = [
  {
    src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1720852067/JUL12%2C24/sdxl-lightning-4step:5f24084160c9089501c1b3545d9be3c27883ae2239b6f412990e82d4a6210f8f/output/bbcqkmxoyw2t27x8wsww.webp",
    alt: "Description of image 1",
    author: "@author1",
    description: "Short description of image 1",
  },
  {
    src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1720810844/JUL12%2C24/sdxl-lightning-4step:5f24084160c9089501c1b3545d9be3c27883ae2239b6f412990e82d4a6210f8f/output/tzza7ii3eady5potwb0n.webp",
    alt: "Description of image 2",
    author: "@author2",
    description: "Short description of image 2",
  },
  {
    src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1720812424/JUL12%2C24/sdxl-lightning-4step:5f24084160c9089501c1b3545d9be3c27883ae2239b6f412990e82d4a6210f8f/output/cfh4oymomokgdyeqeoal.webp",
    alt: "Description of image 2",
    author: "@author2",
    description: "Short description of image 2",
  },
  {
    src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1720810982/JUL12%2C24/sdxl-lightning-4step:5f24084160c9089501c1b3545d9be3c27883ae2239b6f412990e82d4a6210f8f/output/gjpnola6gunpik6x8cuh.webp",
    alt: "Description of image 2",
    author: "@author2",
    description: "Short description of image 2",
  },
  {
    src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1721228068/JUL17%2C24/sdxl-lightning-4step:5f24084160c9089501c1b3545d9be3c27883ae2239b6f412990e82d4a6210f8f/output/xzszfet7rya8cdhchahc.webp",
    alt: "Description of image 2",
    author: "@author2",
    description: "Short description of image 2",
  },
  {
    src: "https://res.cloudinary.com/dcyrpk68d/image/upload/v1720700366/JUL11%2C24/sdxl-lightning-4step:5f24084160c9089501c1b3545d9be3c27883ae2239b6f412990e82d4a6210f8f/output/oxnpwxh0begmavzxqsze.webp",
    alt: "Description of image 2",
    author: "@author2",
    description: "Short description of image 2",
  },
];

export const filters = [
  {
    key: 1,
    title: "All",
    filter: "all",
    icon: Icons.all,
  },
  {
    key: 2,
    title: "Generative AI",
    filter: "generative-ai",
    icon: Icons.generative,
  },
  {
    key: 3,
    title: "Image Editing",
    filter: "image-editing",
    icon: Icons.editor,
  },
  {
    key: 4,
    title: "Image Enhancement",
    filter: "image-enhancement",
    icon: Icons.generator,
  },
  {
    key: 5,
    title: "Video",
    filter: "video",
    icon: Icons.videoGenerator,
  },
];

// ========================== Prompt Form Json data ===============

export const Flux_Aspect_Ratio: AspectRatioOption[] = [
  {
    label: "Instagram Post",
    value: "1:1",
    icon: Instagram,
    color: "#E1306C",
  },
  {
    label: "YouTube Thumbnail",
    value: "16:9",
    icon: Youtube,
    color: "#FF0000",
  },
  {
    label: "Cinematic",
    value: "21:9",
    icon: Maximize2,
    color: "#FFD700",
  },
  {
    label: "Pinterest",
    value: "2:3",
    icon: Pinterest,
    color: "#E60023",
  },
  { label: "Photography", value: "3:2", icon: Camera, color: "#00FF00" },
  {
    label: "Instagram Post (Portrait)",
    value: "4:5",
    icon: Instagram,
    color: "#833AB4",
  },
  {
    label: "Photography",
    value: "5:4",
    icon: ImageIcon,
    color: "#4267B2",
  },
  {
    label: "Instagram Story",
    value: "3:4",
    icon: Instagram,
    color: "#405DE6",
  },
  { label: "Old TV Standard", value: "4:3", icon: Tv, color: "#8B4513" },
  {
    label: "Instagram Story",
    value: "9:16",
    icon: Instagram,
    color: "#000000",
  },
  {
    label: "Vertical Ultra-Wide",
    value: "9:21",
    icon: ImageDown,
    color: "#1DA1F2",
  },
];

export const Stability_Aspect_Ratio: AspectRatioOption[] = [
  {
    label: "Instagram",
    value: "1:1",
    icon: Instagram,
    color: "#E1306C",
  },
  {
    label: "YouTube Thumbnail",
    value: "16:9",
    icon: Youtube,
    color: "#FF0000",
  },
  {
    label: "Cinematic",
    value: "21:9",
    icon: Maximize2,
    color: "#FFD700",
  },
  {
    label: "Pinterest",
    value: "2:3",
    icon: Pinterest,
    color: "#E60023",
  },
  { label: "Photography", value: "3:2", icon: Camera, color: "#00FF00" },
  {
    label: "Instagram Post",
    value: "4:5",
    icon: Instagram,
    color: "#833AB4",
  },
  {
    label: "Medium Format Photography",
    value: "5:4",
    icon: ImageIcon,
    color: "#4267B2",
  },
  {
    label: "Instagram Story / TikTok / Snapchat",
    value: "9:16",
    icon: Instagram,
    color: "#000000",
  },
  {
    label: "Vertical Ultra-Wide",
    value: "9:21",
    icon: ImageDown,
    color: "#1DA1F2",
  },
];

export const Leonardo_Aspect_Ratio: {
  [key: string]: { height: number; width: number };
} = {
  "16:9": { height: 768, width: 1368 }, //done
  "9:16": { height: 1368, width: 768 }, //done
  "4:3": { height: 888, width: 1184 }, //done
  "3:4": { height: 1184, width: 888 }, //done
  "1:1": { height: 1024, width: 1024 }, //done
  "4:5": { height: 1144, width: 912 }, //done
  "5:4": { height: 912, width: 1144 }, //done
  "9:21": { height: 1536, width: 640 }, //done
  "21:9": { height: 640, width: 1536 }, //done
  "3:2": { height: 832, width: 1216 }, //done
  "2:3": { height: 1216, width: 832 }, //done
};

export const styles: Styles = {
  "icon-Creator": [
    // Illustration Category
    {
      name: "Illustrated",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768662/core/zlkdamdebkmdej33gegr.webp",
      category: "Illustration",
    },
    {
      name: "Hand-Drawn",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768658/core/vfpb2fvt8n3morgbviim.webp",
      category: "Illustration",
    },
    {
      name: "Water Color",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768644/core/mlemzjp1a8tqaedjasvm.webp",
      category: "Illustration",
    },
    {
      name: "Cartoonish",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768647/core/hznewmynbfx1i7spyeyc.webp",
      category: "Illustration",
    },
    {
      name: "Doodle",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768631/core/alxpgqxvobtw9kw39rec.webp",
      category: "Illustration",
    },

    // 3D Category
    {
      name: "3D",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724773804/core/ohiwujldueyyhizputs6.webp",
      category: "3D",
    },
    {
      name: "Isometric",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768658/core/oz2l9twvtmqtvt2ch9du.webp",
      category: "3D",
    },

    // Artistic Category
    {
      name: "Mosaic",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768661/core/rc1q3uzduwv4jdecnhr1.webp",
      category: "Artistic",
    },
    {
      name: "Pop Art",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724774276/core/qyqaht9ivrlb1k3ooaqn.webp",
      category: "Artistic",
    },
    {
      name: "Grunge",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768651/core/c5r9wxn3xunytpzxgyvd.webp",
      category: "Artistic",
    },
    {
      name: "Chalkboard Art",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768651/core/aqja74ao0jq8dpsx56j2.webp",
      category: "Artistic",
    },
    {
      name: "Origami",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768632/core/qis82p7cveted5ksgrwx.webp",
      category: "Artistic",
    },
    {
      name: "Clay",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724773883/core/mu0qgsfag5fswrpnubuz.webp",
      category: "Artistic",
    },

    // Effects Category
    {
      name: "Neon",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768657/core/lv8x5iankvoy1tnl4kob.webp",
      category: "Effects",
    },
    {
      name: "Metallic",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768654/core/rphz2zmrprydv0amvpgo.webp",
      category: "Effects",
    },
    {
      name: "Gradient",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768649/core/htkvypdr4ubv05cdkes3.webp",
      category: "Effects",
    },
    {
      name: "Sticker",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768631/core/kkyfdf2md5hhje4pkk8g.webp",
      category: "Effects",
    },

    // Minimalist Category
    {
      name: "Minimalistic",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768655/core/urxfiueehsa0pafctdqc.webp",
      category: "Minimalist",
    },
    {
      name: "Flat",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768631/core/u9rqljeqisldaysf94hh.webp",
      category: "Minimalist",
    },

    // Digital Category
    {
      name: "Realistic",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768652/core/kei5ewcj0h1irltp2ent.webp",
      category: "Digital",
    },
    {
      name: "Polygon",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768627/core/mq7vzbj1nsqtbnbmffcj.webp",
      category: "Digital",
    },
    {
      name: "Pixelated",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724768621/core/tsndojjwhbg5flotqgcc.webp",
      category: "Digital",
    },
  ],
  "creative-Art-Generator": [
    {
      name: "Photographic (Default)",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724772619/core/qkd6ute4vizacs0k04hl.webp",
      category: "Illustration",
    },
    {
      name: "Cinematic",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724772608/core/qjdtoitl2iupufmgbops.webp",
      category: "Creative Art Generator",
    },
    {
      name: "Disney Charactor",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724772613/core/ng7kdcie1dz5gf1pcpii.webp",
      category: "Creative Art Generator",
    },
    {
      name: "Digital Art",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724772609/core/cydaav311xp7icgfhrv4.webp",
      category: "Creative Art Generator",
    },
    {
      name: "Fantasy art",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724772617/core/ulx6v2jhqnytjgrqqkah.webp",
      category: "Creative Art Generator",
    },
    {
      name: "Enhance",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724772616/core/jvvuzv2ovbtacrycf2dv.webp",
      category: "Creative Art Generator",
    },
    {
      name: "Comic book",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724772613/core/qp0nheij00pguw6nwsz2.webp",
      category: "Creative Art Generator",
    },
    {
      name: "Lowpoly",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724772613/core/snvnflb5rzlfoto2tbve.webp",
      category: "Creative Art Generator",
    },
    {
      name: "Line art",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1724772618/core/do2sql4nt626nopxv2im.webp",
      category: "Creative Art Generator",
    },
  ],
  "interior-Design-generator": [
    // Modern & Contemporary Category
    {
      name: "Modern Living Room",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1730446455/NOV01%2C24/Astria/input/hmmvt4ojvcqmzihoynec.jpg",
      category: "Modern",
    },
    {
      name: "Mid-Century Modern Living Room",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732001910/1a3c920d-29be-4431-aea9-460c6a36ced6.png",
      category: "Modern",
    },
    {
      name: "Contemporary Office",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732002212/5765e531-258a-4cb7-8c98-d7bfafedcb45.png",
      category: "Modern",
    },

    // Minimalist Category
    {
      name: "Minimalist Kitchen",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732003769/a1d380e0-d811-441f-9a34-74924f36db9c.png",
      category: "Minimalist",
    },
    {
      name: "Scandinavian Interior",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732003728/54b745d2-fe04-4124-be41-6aa72da5eb3b.png",
      category: "Minimalist",
    },

    // Industrial & Urban Category
    {
      name: "Industrial Loft",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732001870/7b43e8d2-02b8-49fd-bc49-61dea0bdf22c.png",
      category: "Industrial",
    },
    {
      name: "Futuristic Kitchen",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732003653/4d88783a-965e-4eef-9578-9a2ece850224.png",
      category: "Industrial",
    },

    // Cozy & Comfort Category
    {
      name: "Cozy Bedroom",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1730452845/NOV01%2C24/Astria/input/gfquqnnslaxupgdgovds.jpg",
      category: "Cozy",
    },
    {
      name: "Bohemian Interior",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732001956/cf9de361-dbf2-4042-8a4e-98368d365923.png",
      category: "Cozy",
    },
    {
      name: "Coastal Bedroom",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732002012/749f5fc9-d494-4e1a-8afb-a033a0477734.png",
      category: "Cozy",
    },

    // Traditional & Classic Category
    {
      name: "Traditional Study",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732002046/df655566-fbbc-477c-a0b0-c8c4276177af.png",
      category: "Traditional",
    },
    {
      name: "Traditional Dining Room",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732002389/2f9f9f5f-29ec-4b2b-bb59-20142330bda5.png",
      category: "Traditional",
    },

    // Luxury & Elegant Category
    {
      name: "Glamorous Bathroom",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732002132/928baa71-2d31-4262-bc69-59eadc38618b.png",
      category: "Luxury",
    },
    {
      name: "Luxury Penthouse",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732002284/b23e515b-c2e7-439f-bd54-59440e6a2131.png",
      category: "Luxury",
    },
    {
      name: "Glamorous Dressing Room",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732002557/11b43e7c-57bd-4ee6-b76e-f59cc9012f32.png",
      category: "Luxury",
    },

    // Rustic & Country Category
    {
      name: "Rustic Farmhouse Kitchen",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1730446455/NOV01%2C24/Astria/input/hmmvt4ojvcqmzihoynec.jpg",
      category: "Rustic",
    },
    {
      name: "Modern Rustic Bedroom",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732003683/24fb1057-adce-4efe-9946-8fecb5db5a13.png",
      category: "Rustic",
    },

    // Specialty Rooms Category
    {
      name: "Kids' Room",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732002318/0c9fec76-e860-4985-9beb-f1bce69e4d0a.png",
      category: "Specialty",
    },
    {
      name: "Zen Space",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732002340/41c362fc-ae2c-4ef3-9c02-f8c768b343b4.png",
      category: "Specialty",
    },

    // Vintage & Retro Category
    {
      name: "Vintage Bathroom",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732002462/ade0dbea-fff3-46a1-b8d6-ffe4bf52bbdf.png",
      category: "Vintage",
    },

    // Eclectic Category
    {
      name: "Eclectic Living Room",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732002487/c934ed1f-a151-42b8-b3fc-c5aa6d229cab.png",
      category: "Eclectic",
    },

    // Outdoor Category
    {
      name: "Outdoor Patio",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732002528/7f13d500-241d-471b-9dc6-e244f67b9e49.png",
      category: "Outdoor",
    },
  ],
  "Avatar-Generator": Object.keys(aiAvatarPrompt).map((key) => ({
    name: key,
    value: key,
    imageSrc: aiAvatarPrompt[key].imageSrc,
    category: "Avatar",
  })),
  flux: [
    {
      name: "Anime Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67890fa1001ccb091f3d/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "AnimeStyleWallpaperFlux",
      category: "Popular",
    },
    {
      name: "Ghibli-Art",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67890b78001c91d63227/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Ghibli-Art",
      category: "Popular",
    },
    {
      name: "Ghibli-Style",
      imageSrc:
        "https://huggingface.co/Nishitbaria/ghibli-stlye-lora/resolve/main/images/out-0.webp",
      value: "Ghibli-Style",
      category: "Anime & Character",
    },
    {
      name: "Anime Style Character",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673255a6000e1c622720/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "AnimeStyleCharacterFlux",
      category: "Anime & Character",
    },
    {
      name: "Super-Realim-style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673ac446002bdb541f5e/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Super-Realim-style",
      category: "Cinematic & Realistic",
    },
    {
      name: "Flux-Animex-v2",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673ac4310015970b6c3e/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Flux-Animex-v2",
      category: "Anime & Character",
    },
    {
      name: "Midjourney-Mix-Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673aca2800280eac5156/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Midjourney-Mix-Style",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Pixel 3d Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732c05500385d7687bf/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Pixer-3d-Style",
      category: "3D & Dimensional",
    },
    {
      name: "Shadow Projection Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732c1a200004487e2b8/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Shadow-Projection-Flux-LoRA",
      category: "Light & Shadow Effects",
    },
    {
      name: "Electric Blue Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732c484002a88120dd4/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Electric-Blue-style",
      category: "Color Effects",
    },
    {
      name: "Orange Chorma Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732c5760001622ed52f/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Orange-Chroma-Style",
      category: "Color Effects",
    },
    {
      name: "Lime Green Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732c6a8001b8b0e5536/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Lime-Green-Style",
      category: "Color Effects",
    },
    {
      name: "Purple Dream Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732c7ac0026ba928551/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Purple-Dream-Style",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Abstract Cartoon Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732c83300362b85712a/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Abstract-Cartoon-Style",
      category: "Abstract & Artistic",
    },
    {
      name: "Castor Collage Dim",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732ca300026c2d8902e/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Castor-Collage-Dim",
      category: "Abstract & Artistic",
    },
    {
      name: "Castor Dramatic Neon Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732cc11000d8a5ed8f1/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Castor-Dramatic-Neon-Style",
      category: "Neon & Light Effects",
    },
    {
      name: "Yellow Laser Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732cd69003a4f70df9a/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Yellow-Laser-Style",
      category: "Neon & Light Effects",
    },
    {
      name: "Aura Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732ce0a0016c55821fe/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Aura-style",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Intense Red Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732ce5a0022ebcf3f86/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Intense-Red-Style",
      category: "Color Effects",
    },
    {
      name: "Street Bokeh style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732cf54000d48e1faf2/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Street-Bokeh-style",
      category: "Cinematic & Realistic",
    },
    {
      name: "Bold Shadow Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732d0430020ecd493f3/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Bold-Shadow-Style",
      category: "Light & Shadow Effects",
    },
    {
      name: "Clouds Illusion style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732d16700051d75e019/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Clouds-Illusion-style",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Digital Yellow Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732d1f40013d59d1961/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Digital-Yellow-Style",
      category: "Color Effects",
    },
    {
      name: "RDR Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732d315000bf7d3e5ff/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "RDR-Style",
      category: "Retro & Vintage",
    },
    {
      name: "Golden Dust Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732d41d0008e3dd4cb4/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Golden-Dust-Style",
      category: "Color Effects",
    },
    {
      name: "Snoopy Charlie Brown Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732d5700025977e38a9/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Snoopy-Charlie-Brown-Style",
      category: "Cartoon & Character",
    },
    {
      name: "Fractured Line Flare Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732d6100027f70dc896/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Fractured-Line-Flare-Style",
      category: "Abstract & Artistic",
    },
    {
      name: "3D Render Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732d83d0015095bc3e4/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "3D-Render-Style",
      category: "3D & Dimensional",
    },
    {
      name: "Knitted Charaters Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732d8e20007a1c42af6/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Knitted-Charaters-Style",
      category: "Cartoon & Character",
    },
    {
      name: "Purple Gride Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732da0e000c21600f6f/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Purple-Gride-Style",
      category: "Abstract & Artistic",
    },
    {
      name: "Rentro Pixel Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/678914c90001ab61e849/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Rentro-Pixel-Style",
      category: "Popular",
    },
    {
      name: "Mooniverse Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732e0b6002b2fe105b2/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Mooniverse-Style",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Flux Anime Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6732e30300226bf967e3/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Flux-Anime-Style",
      category: "Anime & Character",
    },
    {
      name: "Cine Aesthetic art",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6733419d003005155be8/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Cine-Aesthetic-art",
      category: "Cinematic & Realistic",
    },
    {
      name: "Flux Midjourney Anime Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6733445e002cda99c72a/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Flux-Midjourney-Anime-Style",
      category: "Anime & Character",
    },
    {
      name: "Neon Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6733454300123d82a3b4/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Neon-Style",
      category: "Neon & Light Effects",
    },
    {
      name: "Epic Realism Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67334c0d000b8bb380bf/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Epic-Realism-Style",
      category: "Cinematic & Realistic",
    },
    {
      name: "Logo Design Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67334d9a00161f24008b/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Logo-Design-Style",
      category: "Typography & Design",
    },
    {
      name: "Sticker Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67334e840000b598bd70/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Sticker-Style",
      category: "Typography & Design",
    },
    {
      name: "Ghib sky Illustraction",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67893e16000ac1b3dc3d/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "ghibsky-Illustraction",
      category: "Popular",
    },
    {
      name: "EBook Cover Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67335051000bf0de8d44/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "EBook-Cover-Style",
      category: "Typography & Design",
    },
    {
      name: "Space wallpaper style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673350d80012f13d3d75/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Space-wallpaper-style",
      category: "Sci-Fi & Futuristic",
    },
    {
      name: "Coloring Book Stlye",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67335175002233fbdb34/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Coloring-Book-Stlye",
      category: "Abstract & Artistic",
    },
    {
      name: "Liquid Wallpaper Art",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673351f500036d1b6317/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Liquid-Wallpaper-Art",
      category: "Abstract & Artistic",
    },
    {
      name: "Pencil art",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673352790001030bcf22/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Pencil-art",
      category: "Traditional Art",
    },
    {
      name: "Canopus Typography Ascii Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673353b60030d5486837/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Canopus-Typography-Ascii-Style",
      category: "Typography & Design",
    },
    {
      name: "CyberGaze Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6734387300061c01aef0/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "CyberGaze-Style",
      category: "Sci-Fi & Futuristic",
    },
    {
      name: "Retro neon style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673439eb003dfd882b67/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Retro-neon-style",
      category: "Neon & Light Effects",
    },
    {
      name: "Glowing text pattern",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673447060018ebafbbf2/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Glowing-text-pattern",
      category: "Popular",
    },
    {
      name: "Halloween X Cyberpunk",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6734453800193d1e19d4/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Halloween-X-Cyberpunk",
      category: "Horror & Dark",
    },
    {
      name: "MidJourney Meet flux Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67344def000ccb89b141/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "MidJourney-Meet-flux-Style",
      category: "Popular",
    },
    {
      name: "Dystopian Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673480cd0017471c6707/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Dystopian-Style",
      category: "Horror & Dark",
    },
    {
      name: "Realstic ComicBook Art",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67348309002dacb25756/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Realstic-ComicBook-Art",
      category: "Cinematic & Realistic",
    },
    {
      name: "UmeKnight-Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6734864900133409d1f3/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "UmeKnight-Style",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "StreetArtists Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67348670001bd9979d13/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "StreetArtists-Style",
      category: "Abstract & Artistic",
    },
    {
      name: "Aesthetic Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67348b42003908fc111e/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Aesthetic-Style",
      category: "Abstract & Artistic",
    },
    {
      name: "Horror-Flux-Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67348e6c00275bb1dd8d/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Horror-Flux-Style",
      category: "Horror & Dark",
    },
    {
      name: "Ethereal Midjourney Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67348fe9000372d00546/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Ethereal-Midjourney-Style",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Cartoon Illustration Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67349369001dfab087e7/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Cartoon-Illustration-Style",
      category: "Cartoon & Character",
    },
    {
      name: "3D-Animation-Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673495f90029891b3ddc/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "3D-Animation-Style",
      category: "3D & Dimensional",
    },
    {
      name: "Mystic-Vision-Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673498d8001b4b2ae08a/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Mystic-Vision-Style",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Ars-MidJourney-Watercolor",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6739ddec003024d95ced/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Ars-MidJourney-Watercolor",
      category: "Traditional Art",
    },
    {
      name: "Midjourney Manga Art",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6739ec46001eed90985d/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Midjourney Manga Art",
      category: "Anime",
    },
    {
      name: "Claymation-style_Art",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6739edaa00145f9e3e97/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Claymation-style_Art",
      category: "3D & Dimensional",
    },
    {
      name: "Midjourney Whisper FLUX Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6739f231003959514e07/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Midjourney Whisper FLUX",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Promptcore-Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6739f6a300070f1d3b69/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Promptcore-Style",
      category: "Abstract & Artistic",
    },
    {
      name: "DnD Darkest Fantasy",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6739fcbf000e4b2dd663/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "DnD Darkest Fantasy",
      category: "Horror & Dark",
    },
    {
      name: "Tabletop Miniatures",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6739ff5e0039d273afc9/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Tabletop Miniatures",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "SXZ Dark Fantasy",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a0051002d24298bf1/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "SXZ Dark Fantasy",
      category: "Horror & Dark",
    },
    {
      name: "Space Nebula FLUX",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a02f6000256bbbf93/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Space Nebula FLUX",
      category: "Sci-Fi & Futuristic",
    },
    {
      name: "NeonFantasy style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a03fd003539a00a1b/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "NeonFantasy style",
      category: "Neon & Light Effects",
    },
    {
      name: "MJanime_Flux_LoRa_v3_Final",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a05b5001d664f729f/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "MJanime_Flux_LoRa_v3_Final",
      category: "Anime",
    },
    {
      name: "Fantastic Realism",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a065e003269817d8c/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Fantastic Realism",
      category: "Cinematic & Realistic",
    },
    {
      name: "Neon Cyberpunk FLUX",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a172d001c54f35d17/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Neon Cyberpunk FLUX",
      category: "Sci-Fi & Futuristic",
    },
    {
      name: "Neon Cyberpunk - Animals",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a183f000e7f5672b7/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Neon Cyberpunk - Animals",
      category: "Sci-Fi & Futuristic",
    },
    {
      name: "Vivid Dream - Art Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a19230013eff1cbff/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Vivid Dream - Art Style",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Neon Noir FLUX",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a1be10023358c0a7a/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Neon Noir FLUX",
      category: "Neon & Light Effects",
    },
    {
      name: "Cyberpunk Anime Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a1b2c003535300ede/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Cyberpunk Anime Style",
      category: "Anime",
    },
    {
      name: "Luminous Shadowscape",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a1d2400122a253137/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Luminous Shadowscape",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Neon Cyberpunk - Techno-Mages FLUX",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a1df1001c22eedd63/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Neon Cyberpunk - Techno-Mages FLUX",
      category: "Sci-Fi & Futuristic",
    },
    {
      name: "NewFantasyCore - FLUX",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a1f6b00174a4acef0/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "NewFantasyCore - FLUX",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Flux Ultimator | another Flux detailer",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a21740014dea50b2a/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Flux Ultimator | another Flux detailer",
      category: "Abstract & Artistic",
    },
    {
      name: "Flux Detailer MysticFantasy Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a22f5000978d84b4e/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Flux Detailer] MysticFantasy Style",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "NIJI Anime Style (NIJI V6 - Midjourney)",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a239200217d04670b/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "NIJI Anime Style (NIJI V6 - Midjourney)",
      category: "Anime",
    },
    {
      name: "FLUX - Booster for Glow",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a2605002817766977/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "FLUX - Booster for Glow",
      category: "Neon & Light Effects",
    },
    {
      name: "One humam style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a268f0003ff87c34c/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "One-humam-style",
      category: "Cinematic & Realistic",
    },
    {
      name: "Neurocore Anime Cyberpunk",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67891811003b04c727f5/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Neurocore Anime Cyberpunk",
      category: "Popular",
    },
    {
      name: "Magic of Art",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a28c6002e9464c4bc/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Magic of Art",
      category: "Abstract & Artistic",
    },
    {
      name: "Cute 3d Cartoon Flux",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a2a680029f5a6b1fb/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Cute 3d Cartoon Flux",
      category: "3D & Dimensional",
    },
    {
      name: "Mosaic",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a2bab001a3744deb2/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Mosaic",
      category: "Abstract & Artistic",
    },
    {
      name: "Niji FLUX",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a2cba000b203f251c/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Niji FLUX",
      category: "Anime",
    },
    {
      name: "FLUX-Oil-painting",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a2d480027e1a29481/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "FLUX-Oil-painting",
      category: "Artistic Styles",
    },
    {
      name: "Midjourney Dreamlike Fantasy FLUX",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a2edd0012c7306736/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Midjourney Dreamlike Fantasy FLUX",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Graffiti Logo Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a2f570015660dccc2/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Graffiti Logo Style",
      category: "Urban & Street",
    },
    {
      name: "Flux.1 Turbo Detailer",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a30ff0003a2d72dae/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Flux.1 Turbo Detailer",
      category: "Abstract & Artistic",
    },
    {
      name: "Dark Fantasy Style flux",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a322e0016651e9b6b/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Dark Fantasy Style flux",
      category: "Horror & Dark",
    },
    {
      name: "FS Anime Fantasy Aesthetics",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a33120036071a8fe3/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "FS Anime Fantasy Aesthetics",
      category: "Anime",
    },
    {
      name: "Neon Cyberpunk Papercut",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a33db002222fbd16a/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Neon Cyberpunk Papercut",
      category: "Sci-Fi & Futuristic",
    },
    {
      name: "Midjourney Lucid Dreams FLUX",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a34de00223b7b240e/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Midjourney Lucid Dreams FLUX",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Ultima",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a350800223ed2900c/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Ultima",
      category: "Abstract & Artistic",
    },
    {
      name: "World of Green Mist",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673a355e002cc6a0fecd/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "World of Green Mist",
      category: "Fantasy & Dreamlike",
    },
    {
      name: "Movie Poster",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/678919ba000c224fed3a/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Movie Poster",
      category: "Popular",
    },
    {
      name: "Gart-LoRA",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67893666002a0e8892d0/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Flux-GArt-LoRA",
      category: "Popular",
    },
    {
      name: "Pencil Drawing Enhancer",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673ab4e8000040111a30/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Pencil Drawing Enhancer",
      category: "Artistic Styles",
    },
    {
      name: "Crystal Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673ab5ca0018694b945b/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Crystal Style",
      category: "Abstract & Artistic",
    },
    {
      name: "Line Design",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673ab9390023673d3e27/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Line Design",
      category: "Abstract & Artistic",
    },
    {
      name: "Semi-Realistic Anime Art Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673aba0f001da6b8cef2/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Semi-Realistic Anime Art Style",
      category: "Anime",
    },
    {
      name: "3D Wool Felt",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673abbb00006d49322c8/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "3D Wool Felt",
      category: "3D & Dimensional",
    },
    {
      name: "Realistic Portrait - Midjourney",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673abc39000c9addeacc/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Realistic Portrait - Midjourney",
      category: "Cinematic & Realistic",
    },
    {
      name: "FLUX The Secret Lab Lora",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673abd18002338373975/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "FLUX The Secret Lab Lora",
      category: "Abstract & Artistic",
    },
    {
      name: "Impressionism",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673abe9a0004014244be/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Impressionism",
      category: "Artistic Styles",
    },
    {
      name: "flux-back-light",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729595116/a9ab5986-9249-4e8c-b562-46b2eb50d313.png",
      value: "fluxBackLight",
      category: "Neon & Light Effects",
    },
    {
      name: "Cute 3D Style",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729252102/f3613ca1-16fa-4cb7-979d-df5436f2f600.png",
      value: "Cute3DStyleFlux",
      category: "3D & Dimensional",
    },
    {
      name: "Newspaper Illustration Style",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729255041/052a9ffd-f5c2-4493-8938-be54c8e4d456.png",
      value: "NewspaperIllustrationStyleFlux",
      category: "Artistic Styles",
    },
    {
      name: "Neon style Tokyo",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729258418/4b6741a6-1446-4f04-9826-c2d6fdb36712.png",
      value: "NeonStyleTokyoFlux",
      category: "Neon & Light Effects",
    },
    {
      name: "360 view style",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729258709/c1788720-33a2-4ec0-b47b-4b265f5a36f7.png",
      value: "360ViewStyleFlux",
      category: "3D & Dimensional",
    },
    {
      name: "70s-bands style",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729258911/ac7906d6-00b0-4976-baec-0e7474724b22.png",
      value: "70sBandsStyleFlux",
      category: "Retro & Vintage",
    },
    {
      name: "Youtube thumbnail style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673354d0000621843c79/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "YoutubeThumbnailStyleFlux",
      category: "Media & Pop Culture",
    },
    {
      name: "Cyberpunk style",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729260436/c129474d-7bd9-4bd5-ab79-50317e73b482.png",
      value: "CyberpunkStyleFlux",
      category: "Sci-Fi & Futuristic",
    },
    {
      name: "Sketch Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/6789375e000e11b88be4/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "SketchStyleFlux",
      category: "Popular",
    },
    {
      name: "A miniature style",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729261228/054bed32-71c9-4f8d-93bf-b148d17728a8.png",
      value: "MiniatureStyleFlux",
      category: "3D & Dimensional",
    },
    {
      name: "Tattoo Art",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729272478/72670e80-3538-462c-8a7b-11bd49e64bbf.png",
      value: "TattooArtFlux",
      category: "Abstract & Artistic",
    },
    {
      name: "Gta style",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729272765/e3f4b87f-cc7e-499c-ab35-ea19bd540128.png",
      value: "GtaStyleFlux",
      category: "Media & Pop Culture",
    },
    {
      name: "GLowing Art Style",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/673252640015d1e517ff/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "GlowingArtStyleFlux",
      category: "Neon & Light Effects",
    },
    {
      name: "Chinese Line Art",
      imageSrc:
        "https://cloud.appwrite.io/v1/storage/buckets/67324d84000ed4c9396f/files/67324da6002827160cb2/view?project=67324d6d000cd466675b&project=67324d6d000cd466675b&mode=admin",
      value: "Chinese-Line-Art",
      category: "Artistic Styles",
    },
    {
      name: "Vector Art",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729273160/f1a180da-4ce5-4984-88a2-f78e526a9b70.png",
      value: "VectorArtFlux",
      category: "Artistic Styles",
    },
    {
      name: "Pattern Art",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729274083/e2483df9-a38e-4146-b3bb-60ffd69431f7.png",
      value: "PatternArtFlux",
      category: "Abstract & Artistic",
    },
    {
      name: "red-cinema",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1729274180/82627509-167a-4c57-b6b1-165034d0bf11.png",
      value: "RedCinemaFlux",
      category: "Cinematic & Realistic",
    },
  ],
  "leonardo-ai": [
    {
      name: "Leonardo Phoenix",
      value: "Leonardo Phoenix",
      imageSrc:
        "https://cdn.leonardo.ai/users/384ab5c8-55d8-47a1-be22-6a274913c324/generations/5e150d17-c580-4ec4-afb6-719884213508/Default_A_majestic_phoenix_wrapped_around_stylized_title_text_0.jpg",
      category: "Leonardo AI",
    },
    {
      name: "Leonardo Anime XL",
      value: "Leonardo Anime XL",
      imageSrc:
        "https://cdn.leonardo.ai/users/384ab5c8-55d8-47a1-be22-6a274913c324/generations/16cbffcc-8672-47d6-8738-d22167dcea3f/Default_A_lush_vibrant_anime_hero_figure_emerges_from_the_shad_0.jpg",
      category: "Leonardo AI",
    },
    {
      name: "Leonardo Diffusion XL",
      value: "Leonardo Diffusion XL",
      imageSrc:
        "https://cdn.leonardo.ai/users/384ab5c8-55d8-47a1-be22-6a274913c324/generations/9ea08719-5fd1-4df7-9adc-5218637cba17/Leonardo_Diffusion_XL_a_brain_suspended_in_midair_bathed_in_a_1.jpg",
      category: "Leonardo AI",
    },
    {
      name: "Leonardo Vision XL",
      value: "Leonardo Vision XL",
      imageSrc:
        "https://cdn.leonardo.ai/users/384ab5c8-55d8-47a1-be22-6a274913c324/generations/bc0a7117-ad5e-4754-8648-6412cc554478/Leonardo_Vision_XL_A_gritty_unedited_photograph_perfectly_capt_2.jpg",
      category: "Leonardo AI",
    },
    {
      name: "Leonardo Kino XL",
      value: "Leonardo Kino XL",
      imageSrc:
        "https://cdn.leonardo.ai/users/384ab5c8-55d8-47a1-be22-6a274913c324/generations/38c684e6-702f-446a-b99b-649462d6a3d6/Leonardo_Kino_XL_cinematic_photo_of_a_surreal_adventurer_on_a_2.jpg",
      category: "Leonardo AI",
    },
    {
      name: "AlbedoBase XL",
      value: "AlbedoBase XL",
      imageSrc:
        "https://cdn.leonardo.ai/users/384ab5c8-55d8-47a1-be22-6a274913c324/generations/6a441e3f-594d-442f-b70b-0d867a09e589/AlbedoBase_XL_A_sleek_and_menacing_dwarf_his_metallic_body_gle_3.jpg",
      category: "Leonardo AI",
    },
    {
      name: "SDXL 1.0",
      value: "SDXL 1.0",
      imageSrc:
        "https://cdn.leonardo.ai/users/384ab5c8-55d8-47a1-be22-6a274913c324/generations/9ed4ccd8-649c-4a59-a7bb-9f5b704a91b1/SDXL_09_a_beautiful_woman_vivid_striking_colors_cinematic_phot_0.jpg",
      category: "Leonardo AI",
    },
    {
      name: "3D Animation Style",
      value: "3D Animation Style",
      imageSrc:
        "https://cdn.leonardo.ai/users/384ab5c8-55d8-47a1-be22-6a274913c324/generations/0e85d140-3ea0-4179-a708-ae95bf9329a3/3D_Animation_Style_a_masterpiece_image_of_an_older_tired_and_b_2.jpg",
      category: "Leonardo AI",
    },
    {
      name: "RPG v5",
      value: "RPG v5",
      imageSrc:
        "https://cdn.leonardo.ai/users/384ab5c8-55d8-47a1-be22-6a274913c324/generations/ad43331b-c80c-40e5-8462-304aaaef3584/RPG_v5_a_stunning_photograph_of_a_grotesque_alien_creature_wit_1.jpg",
      category: "Leonardo AI",
    },
    {
      name: "DreamShaper v7",
      value: "DreamShaper v7",
      imageSrc:
        "https://cdn.leonardo.ai/users/384ab5c8-55d8-47a1-be22-6a274913c324/generations/8ab5c76a-eefb-4801-817f-458f68958db7/DreamShaperV6_a_masterpiece_image_of_Splash_art_music_album_ar_6.jpg",
      category: "Leonardo AI",
    },
  ],
  "text-to-Image": [
    {
      name: "photon",
      value: "photon",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1733507949/core/s6voofqsz7k900cftau5.jpg",
      category: "Luma",
    },
    {
      name: "photon-flash",
      value: "photon-flash",
      imageSrc:
        "https://res.cloudinary.com/djqjag779/image/upload/v1733507835/core/dswmpl1sa2vf6nyewnaj.jpg",
      category: "Luma",
    },
    {
      name: "flux-1.1-pro-ultra",
      value: "flux-1.1-pro-ultra",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732290948/a1bb0d05-b776-4e0b-94fe-081b9d9f061f.png",
      category: "Flux",
    },
    {
      name: "recraft-v3",
      value: "recraft-v3",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732291953/287f1423-15e5-4f50-bf63-54390f94ec38.png",
      category: "Recraft",
    },
    {
      name: "recraft-v3-svg",
      value: "recraft-v3-svg",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732291064/2d2c59aa-aaec-4e84-a113-e459832f9610.png",
      category: "Recraft",
    },
    {
      name: "ideogram-v2",
      value: "ideogram-v2",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732291126/4ec0d4d7-a029-4cdf-96db-3f87e972bdc0.png",
      category: "Ideogram",
    },
    {
      name: "ideogram-v2-turbo",
      value: "ideogram-v2-turbo",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732291134/7dcf8c51-9ee4-409a-8f60-c7e426e69f19.png",
      category: "Ideogram",
    },
    {
      name: "flux-schnell",
      value: "flux-schnell",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732290872/6d171667-7304-4452-90f1-ffcf252f6e3e.png",
      category: "Flux",
    },
    {
      name: "flux-pro",
      value: "flux-pro",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732290910/f5e7bf31-c83d-4a62-a723-6781e4572cf0.png",
      category: "Flux",
    },
    {
      name: "flux-dev",
      value: "flux-dev",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732290835/999796b5-85ff-4533-a213-40fe3ba01683.png",
      category: "Flux",
    },
    {
      name: "flux-1.1-pro",
      value: "flux-1.1-pro",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732290795/bb758100-97b2-4152-9096-e51fad5c0da7.png",
      category: "Flux",
    },
    {
      name: "Stable Image Ultra",
      value: "Stable Image Ultra",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732291548/a0bf35e6-3b2f-4d60-afe6-66d650133f3f.png",
      category: "Stability",
    },
    {
      name: "Stable Image Core",
      value: "Stable Image Core",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732291851/62ae1841-e863-42b2-9f88-192dc6fad1f0.png",
      category: "Stability",
    },
    {
      name: "Stable Diffusion 3.5 Large",
      value: "sd3.5-large",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732291480/7aa72483-f9df-462e-917a-88eb81088dfb.png",
      category: "Stability",
    },
    {
      name: "Stable Diffusion 3.5 Large Turbo",
      value: "sd3.5-large-turbo",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732291448/22adec29-eafc-4625-a009-881d6bf10f73.png",
      category: "Stability",
    },
    {
      name: "Stable Diffusion 3.5 Medium",
      value: "sd3.5-medium",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732291215/062c2210-4b81-4529-8ed5-f518bdb79816.png",
      category: "Stability",
    },
    {
      name: "Dalle-3",
      value: "dall-e-3",
      imageSrc:
        "https://res.cloudinary.com/dcyrpk68d/image/upload/v1732291661/4c352a34-5c6b-4e2b-83fa-2aa48e303842.png",
      category: "OpenAi",
    },
  ],
};

export const dynamicPricing = {
  basePrice: 5,
  maxPrice: 100,
  baseCredits: 500,
  priceSteps: {
    // 5$ steps until 60$
    upTo60: {
      step: 5,
      limit: 60,
      creditsMultiplier: 100, // 100 credits per dollar
    },
    // 10$ steps from 60$ to 100$
    upTo100: {
      step: 10,
      limit: 100,
      creditsMultiplier: 120, // 120 credits per dollar (bonus for higher tiers)
    },
  },
  productIds: {
    // Monthly product IDs
    monthly: {
      "5": "pdt_YlrMc8DClvd9kqeLiodw5",
      "10": "pdt_45cudvYN7K8vQ6p74aWwa",
      "15": "pdt_4tW9SmR63alNvcsZAFMA5",
      "20": "pdt_V3VCqooaGA5Inm9GW5jpI",
      "25": "pdt_JvsgZHuum2KHyFAlMatAe",
      "30": "pdt_YEcrtr6OORtF8Subj6oUg",
      "35": "pdt_YEcrtr6OORtF8Subj6oUg",
      "40": "pdt_Lpe3yWSIkHdk2xFsle8qX",
      "45": "pdt_8EqcvlfXZBreqkhqwBiQ0",
      "50": "pdt_zGgLcnN5PPHaBB2DIuK2s",
      "55": "pdt_mpNjV6HgnVZgIF2UOQj5S",
      "60": "pdt_jRvudLp5X2Y0VyKIMS6gT",
      "65": "pdt_EmFOqD0hEGoSCZEST8bOA",
      "70": "pdt_sxanFgwtBEvhK1TnrH9CB",
      "80": "pdt_H65XNSJEOcpNl99RccENA",
      "90": "pdt_Hh0wURmBbNsD6KRyBH5Ix",
      "100": "pdt_bICMnXzOoTrAs65ZUyWMQ",
    },

    // Yearly product IDs (20% discount applied)
    yearly: {
      "48": "pdt_vskwU1SDo670Bhdqzgh21", // $5/month = $60/year - 20% = $48/year
      "96": "pdt_yzCshZh7R0rN06m0zXi7b", // $10/month = $120/year - 20% = $96/year
      "144": "pdt_mhrICeXBr1dKjA6LFBxlN", // $15/month = $180/year - 20% = $144/year
      "192": "pdt_qrOCPjoALEFJ2MjRfXmCg", // $20/month = $240/year - 20% = $192/year
      "240": "pdt_v1MPQOQO8l1CtWE7PdKuO", // $25/month = $300/year - 20% = $240/year
      "288": "pdt_z6W9Gj1i2aNBdEUcD3oCb", // $30/month = $360/year - 20% = $288/year
      "336": "pdt_Ty3h9iHuW8NlH78U4iHp5", // $35/month = $420/year - 20% = $336/year
      "384": "pdt_QiVVHoGP0jtAhFsZXMEUA", // $40/month = $480/year - 20% = $384/year
      "432": "pdt_OxIGsUtaa4kwiCETmUGtp", // $45/month = $540/year - 20% = $432/year
      "480": "pdt_3lo6oYSeJzIk0M8NSwxby", // $50/month = $600/year - 20% = $480/year
      "528": "pdt_gyx8nB6OHwJO5VHy2pf25", // $55/month = $660/year - 20% = $528/year
      "576": "pdt_0NDi5HIdrbH6nzkp8jOLE", // $60/month = $720/year - 20% = $576/year
      "624": "pdt_nms9pfOTCdQOCmSxxOHTp", // $65/month = $780/year - 20% = $624/year
      "672": "pdt_Dsp2KR30h9tQPlnTemwz3", // $70/month = $840/year - 20% = $672/year
      "768": "pdt_y38Hnllp8wlOmL3KBdAqH", // $80/month = $960/year - 20% = $768/year
      "864": "pdt_z66yGnojb89NLZFLCZKEp", // $90/month = $1080/year - 20% = $864/year
      "960": "pdt_hmQNrdy2vHDk4waxqrsFZ", // $100/month = $1200/year - 20% = $960/year
    },
  },
};
